import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';

import EditAP from '../../components/AP/EditAP/editAP';
import {
  fetchAPInvoices,
  fetchAPDetail,
  fetchAPCredits,
  editAP,
  deleteAP,
  clearCredits,
  clearAPForm,
} from '../../actions/arap_actions';
import { setDefaultOfForm } from '../../actions/purchaseOrders_actions';
import { checkPassword, clearCheckPassword } from '../../actions/settings_actions';

const isNumeric = function (n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
};

const validate = (values) => {
  const errors = {};

  if (values.TotalPayment && !isNumeric(values.TotalPayment)) {
    errors.TotalPayment = 'Enter a number!';
  }

  if (values.TotalPayment < 0) {
    errors.TotalPayment = 'Positive numbers only!';
  }

  if (values.Discount && !isNumeric(values.Discount)) {
    errors.Discount = 'Enter a number!';
  }

  if (values.Discount && values.Discount < 0) {
    errors.Discount = 'Positive numbers only!';
  }

  if (values.waiveAmount && !isNumeric(values.waiveAmount)) {
    errors.waiveAmount = 'Enter a number!';
  }

  if (!values.Vendor) {
    errors.Vendor = 'Required';
  }

  if (!values.Account) {
    errors.Account = 'Required';
  }

  if (!values.TotalPayment) {
    errors.TotalPayment = 'Required';
  }

  if (!values.Method) {
    errors.Method = 'Required';
  }

  return errors;
};

const editAPForm = reduxForm({
    form: 'editAP',
    destroyOnUnmount: true,
    touchOnChange: true,
    touchOnBlur: false,
    validate,
})(EditAP);

const selector = formValueSelector('editAP');

function mapStateToProps(state) {
    const vendorID = selector(state, 'Vendor');
    const credits = selector(state, 'Credits');

    const invoiceDate = selector(state, 'InvoiceDate');
    const paymentDate = selector(state, 'PaymentDate');

    const method = selector(state, 'Method');
    const checkNum = selector(state, 'CheckNum');
    const account = selector(state, 'Account');
    const discount = selector(state, 'Discount');
    const totalPayment = selector(state, 'TotalPayment');
    const waiveAmount = selector(state, 'WaiveAmount');
    const note = selector(state, 'Note');
    return {
        vendorID,
        credits,
        invoiceDate,
        paymentDate,
        method,
        checkNum,
        account,
        discount,
        totalPayment,
        waiveAmount,
        note,
        invoices: state.arap.invoices,
        invoicesIsLoading: state.arap.invoicesIsLoading,
        invoicesError: state.arap.invoicesError,
        apCreated: state.arap.apCreated,
        apEdited: state.arap.apEdited,
        apEditError: state.arap.apEditError,
        apIsEditing: state.arap.apIsEditing,
        apDetail: state.arap.apDetail,
        apDetailError: state.arap.apDetailError,
        apDetailIsLoading: state.arap.apDetailIsLoading,
        originalCheckNumber: state.arap.originalCheckNumber,

        credits: state.arap.credits,
        creditsIsLoading: state.arap.creditsIsLoading,
        creditsError: state.arap.creditsError,

        userPermissions: state.auth.userPermissions,
        checkPassword: state.settings.checkPassword,
        checkPasswordSuccess: state.settings.checkPasswordSuccess,
        checkPasswordFailure: state.settings.checkPasswordFailure,

        initialValues: state.arap.apDetail,
    };
}


export default connect(mapStateToProps, {
  fetchAPInvoices,
  fetchAPDetail,
  fetchAPCredits,
  editAP,
  deleteAP,
  clearCredits,
  clearAPForm,
  checkPassword,
  clearCheckPassword,
  setDefaultOfForm,
})(editAPForm);



// WEBPACK FOOTER //
// ./master/jsx/containers/AP/editAP.jsx